import { Controller } from "@hotwired/stimulus"

// Tabs switching : preserve scroll window au changement de tab.
// On prend le contrôle complet de la navigation frame (preventDefault) pour éviter
// tout scroll auto de Turbo. On set frame.src manuellement puis on restore window.scrollY.
export default class extends Controller {
  activate(event) {
    const clicked = event.currentTarget
    const frameId = clicked.dataset.turboFrame
    const href = clicked.getAttribute("href") || clicked.href

    // Toggle état actif immédiatement pour feedback instant
    this.element.querySelectorAll(".entity-tab, .rw-tab").forEach((tab) => {
      tab.classList.toggle("is-active", tab === clicked)
    })

    if (!frameId || !href) return

    const frame = document.getElementById(frameId)
    if (!frame) return

    // Bloque la nav Turbo par défaut, on contrôle tout
    event.preventDefault()

    const savedScrollY = window.scrollY
    const savedScrollX = window.scrollX
    const restore = () => {
      if (window.scrollY !== savedScrollY) {
        window.scrollTo({ top: savedScrollY, left: savedScrollX, behavior: "instant" })
      }
    }

    // Restore à chaque étape du lifecycle du frame pour neutraliser tout scroll auto
    const onLoad = () => {
      restore()
      // Couvre les re-layouts post-load (images, count-up, etc.)
      requestAnimationFrame(restore)
      setTimeout(restore, 50)
      setTimeout(restore, 150)
    }
    frame.addEventListener("turbo:frame-load", onLoad, { once: true })

    // Déclenche la nav frame en mettant src (Turbo la détecte et fetch)
    frame.src = href
  }
}
